import { ApiWrapper, PublicWebinarData, GetPublicWebinarDataRequest } from '../../types';
import { PublicWebinarUrl, PublicWebinarFullnameRequest } from '../../types/bbb';
import { JBaseApi } from '../base';
import { OF } from '../../util';

export class JBbbApi extends JBaseApi {
    public publicWebinarFullname(params: PublicWebinarFullnameRequest): Promise<ApiWrapper<PublicWebinarUrl>> {
        return this.network.post({
            o: 'bigBlueButton',
            f: 'publicWebinarFullname',
            ...params,
        } as OF);
    }

    public getPublicWebinarData(params: GetPublicWebinarDataRequest): Promise<ApiWrapper<PublicWebinarData>> {
        return this.network.post({
            o: 'bigBlueButton',
            f: 'getPublicWebinarData',
            ...params,
        } as OF);
    }

    public recordingDelete(
        id: number,
        filename: string,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'bigBlueButton',
                f: 'videoRecordingDelete',
                id,
                filename,
            } as OF,
            options?.signal,
        );
    }

    public resolveUrl(params: { uri: string }, signal?: AbortSignal): Promise<ApiWrapper<PublicWebinarUrl>> {
        return this.network.post(
            {
                o: 'bigBlueButton',
                f: 'resolveUrl',
                ...params,
            } as OF,
            signal,
        );
    }
}
